import { CustomSelect, Label, SelectOption } from '@consigli/facade';
import { Country } from '@consigli/types';
import { useMemo, type FC, useCallback } from 'react';
import { type Control, useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ProjectInputs } from '@/util/types';

interface ProjectCountryFieldProps {
  control: Control<ProjectInputs>;
}

export const ProjectCountryField: FC<ProjectCountryFieldProps> = ({ control }) => {
  const { t } = useTranslation();

  const countryChoices: SelectOption[] = useMemo(
    () =>
      [
        // { label: t('country.argentina'), value: Country.ARGENTINA },
        { label: t('country.australia'), value: Country.AUSTRALIA },
        // { label: t('country.bahrain'), value: Country.BAHRAIN },
        // { label: t('country.belarus'), value: Country.BELARUS },
        // { label: t('country.belgium'), value: Country.BELGIUM },
        // { label: t('country.bolivia'), value: Country.BOLIVIA },
        // { label: t('country.brazil'), value: Country.BRAZIL },
        { label: t('country.canada'), value: Country.CANADA },
        // { label: t('country.chile'), value: Country.CHILE },
        { label: t('country.china'), value: Country.CHINA },
        // { label: t('country.colombia'), value: Country.COLOMBIA },
        // { label: t('country.czechia'), value: Country.CZECHIA },
        { label: t('country.denmark'), value: Country.DENMARK },
        { label: t('country.finland'), value: Country.FINLAND },
        { label: t('country.france'), value: Country.FRANCE },
        { label: t('country.germany'), value: Country.GERMANY },
        // { label: t('country.ghana'), value: Country.GHANA },
        // { label: t('country.greece'), value: Country.GREECE },
        { label: t('country.hong-kong'), value: Country.HONG_KONG },
        { label: t('country.hungary'), value: Country.HUNGARY },
        { label: t('country.iceland'), value: Country.ICELAND },
        // { label: t('country.india'), value: Country.INDIA },
        // { label: t('country.indonesia'), value: Country.INDONESIA },
        { label: t('country.ireland'), value: Country.IRELAND },
        // { label: t('country.italy'), value: Country.ITALY },
        { label: t('country.japan'), value: Country.JAPAN },
        // { label: t('country.kazakhstan'), value: Country.KAZAKHSTAN },
        // { label: t('country.macao'), value: Country.MACAO },
        // { label: t('country.malaysia'), value: Country.MALAYSIA },
        // { label: t('country.mexico'), value: Country.MEXICO },
        // { label: t('country.monaco'), value: Country.MONACO },
        // { label: t('country.mozambique'), value: Country.MOZAMBIQUE },
        // { label: t('country.myanmar'), value: Country.MYANMAR },
        { label: t('country.netherlands'), value: Country.NETHERLANDS },
        { label: t('country.new-zealand'), value: Country.NEW_ZEALAND },
        { label: t('country.norway'), value: Country.NORWAY },
        // { label: t('country.oman'), value: Country.OMAN },
        // { label: t('country.panama'), value: Country.PANAMA },
        // { label: t('country.peru'), value: Country.PERU },
        // { label: t('country.philippines'), value: Country.PHILIPPINES },
        // { label: t('country.poland'), value: Country.POLAND },
        // { label: t('country.qatar'), value: Country.QATAR },
        // { label: t('country.romania'), value: Country.ROMANIA },
        // { label: t('country.russian-federation'), value: Country.RUSSIAN_FEDERATION },
        { label: t('country.saudi-arabia'), value: Country.SAUDI_ARABIA },
        { label: t('country.singapore'), value: Country.SINGAPORE },
        // { label: t('country.slovakia'), value: Country.SLOVAKIA },
        // { label: t('country.south-africa'), value: Country.SOUTH_AFRICA },
        { label: t('country.spain'), value: Country.SPAIN },
        // { label: t('country.sri-lanka'), value: Country.SRI_LANKA },
        { label: t('country.sweden'), value: Country.SWEDEN },
        // { label: t('country.switzerland'), value: Country.SWITZERLAND },
        // { label: t('country.taiwan'), value: Country.TAIWAN },
        // { label: t('country.thailand'), value: Country.THAILAND },
        // { label: t('country.trinidad-and-tobago'), value: Country.TRINIDAD_AND_TOBAGO },
        // { label: t('country.ukraine'), value: Country.UKRAINE },
        // { label: t('country.united-arab-emirates'), value: Country.UNITED_ARAB_EMIRATES },
        { label: t('country.united-kingdom'), value: Country.UNITED_KINGDOM },
        { label: t('country.united-states'), value: Country.UNITED_STATES },
        // { label: t('country.vietnam'), value: Country.VIETNAM },
        { label: t('country.other'), value: Country.OTHER },
      ].sort((a, b) => a.label.localeCompare(b.label)),
    [t],
  );

  const { field, fieldState } = useController({
    name: 'country',
    control,
    rules: { required: `${t('project-creation.country-required')}*` },
  });

  const onCountryChange = useCallback(
    (selectedOptions: SelectOption[]): void => {
      field.onChange(selectedOptions.length > 0 ? selectedOptions[0].value : null);
    },
    [field],
  );

  return (
    <div>
      <Label text={t('project-creation.country-label')} />
      <p className="text-xs text-day-neutral-subtle -mt-1.5 mb-2">
        {t('project-creation.country-help-text')}
      </p>
      <CustomSelect
        options={countryChoices}
        onChange={onCountryChange}
        value={field.value ? countryChoices.filter((option) => option.value === field.value) : []}
        placeholder={t('project-creation.country-placeholder')}
        noOptionsMessage={t('custom-select.no-options')}
        className="w-full"
        isClearable
      />
      {fieldState.invalid && (
        <div className={'text-sm my-1 text-error-dark'}>{fieldState.error?.message}</div>
      )}
    </div>
  );
};
